module.exports = __webpack_public_path__ + "img/50.bc5826da.jpg";